var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#d68828;stroke:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M50.3,57.9H21.21a2.76,2.76,0,0,1-2.75-2.76v-42a2.76,2.76,0,0,1,2.75-2.76H37.37a2.77,2.77,0,0,1,2.76,2.76v9.7a.47.47,0,0,0,.48.47H50.3a2.77,2.77,0,0,1,2.76,2.76V55.14A2.77,2.77,0,0,1,50.3,57.9ZM21.21,12.65a.48.48,0,0,0-.47.48v42a.48.48,0,0,0,.47.48H50.3a.49.49,0,0,0,.48-.48V26.06a.48.48,0,0,0-.48-.48H40.62a2.76,2.76,0,0,1-2.76-2.75v-9.7a.48.48,0,0,0-.47-.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M51.27,25.91a1.14,1.14,0,0,1-.81-.34L37.54,12.65A1.14,1.14,0,1,1,39.15,11L52.07,24a1.15,1.15,0,0,1,0,1.61,1.17,1.17,0,0,1-.83.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-2",
    d: "M35.76,35.28H29.29a1.14,1.14,0,0,1,0-2.27h6.47a1.14,1.14,0,0,1,0,2.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-2",
    d: "M42.22,41.74H29.29a1.14,1.14,0,0,1,0-2.27H42.22a1.14,1.14,0,0,1,0,2.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-2",
    d: "M35.76,48.21H29.29a1.14,1.14,0,0,1,0-2.27h6.47a1.14,1.14,0,0,1,0,2.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.69a5ecd1d23f7c9de67286442658a505.svg";
export { ForwardRef as ReactComponent };